import { type ReactNode } from 'react'
import { Select } from '@base-ui/react/select'

function SelectPortal({ children }: { children: ReactNode }) {
  return <Select.Portal>{children}</Select.Portal>
}

export { SelectPortal }
